<template>
	<div class="footdiv">
		<!-- <img src="../../assets/maps/5@2x.png" alt="" class="bottom-footer" /> -->
		<div class="card-carousel-wrapper">
			<div @click="moveCarousel(-1)">
				<div class="card-carousel--nav__left" :disabled="atHeadOfList" style="margin-right: -20px;"></div>
			
			</div>
			<div class="card-carousel">
				<div class="card-carousel--overflow-container">
					<div class="card-carousel-cards" ref='carouselW' :style="{
              transform: 'translateX' + '(' + currentOffset + 'px' + ')',
            }">
						<div class="card-carousel--card" v-for="(item, index) in CarouselData" :key="index"
							@click="go(item)">
							<ul class="header-sub"  v-if="item.child">
                        <li v-for="(v1,i1) in item.child" :key="i1" @click.stop="go(v1)">{{v1.name}}</li>
                            </ul>
							<!-- <div class="card-carousel--card--footer"></div> -->
							<p>{{ item.name }}</p>
						</div>
					</div>
				</div>
			</div>
			<div @click="moveCarousel(1)">
				<div class="card-carousel--nav__right" :disabled="atEndOfList"></div>
			
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				currentOffset: 0,
				windowSize: 3,
				paginationFactor: 90,
				active: -1,
				currentOffsetActive: 1,
				maxWidth: 0,
                CarouselData:[]
			};
		},
	props:{
        dataList:{
            default:[]
        }   
    },
	watch:{
        dataList:function(v1,v2){
            if(v1!=v2){
                this.CarouselData=this.dataList
            }
        }
    },
		computed: {
			atEndOfList() {
				return (
					this.maxWidth <= this.paginationFactor * this.currentOffsetActive
				);
			},
			atHeadOfList() {
				return this.currentOffset === 0;
			},
		},
		mounted() {},
		methods: {
             go(v) {
                console.log(v,"vvv")
               if(v.aa == 'jiucuo'){         
                let arr = window.location.href.split('jiucuo')
                let arr1 = arr[0].split('index')
                let url = `${arr1[0]}/#/gwjc`
                this.$router.replace(url)
               }
               if(v.aa == 'http://wpa.qq.com/msgrd?v=3&uin=1420561821&site=qq&menu=yes'){
                   window.open(v.aa);
                   return;
               }
                if(!v.parent){
                    location.href = `${v.aa}?id=${v.id}`;
                }else{
                    location.href = `${v.aa}?id=${v.id}&parent=${v.parent.id}`;
                }
                
            },
			moveCarousel(direction) {
				// console.log('CarouselData', this.$refs.carouselW.clientWidth)
				this.paginationFactor = this.$refs.carouselW.clientWidth;
				this.maxWidth = this.$refs.carouselW.scrollWidth;
				// Find a more elegant way to express the :style. consider using props to make it truly generic
				if (direction === 1 && !this.atEndOfList) {
					this.currentOffsetActive++;
					this.currentOffset -= this.paginationFactor;
				} else if (direction === -1 && !this.atHeadOfList) {
					this.currentOffsetActive--;
					this.currentOffset += this.paginationFactor;
				}
			},
			cont(item, index) {
				let CarouselData = this.CarouselData;
				let checkedNums = 0;
				CarouselData[index].checked = !CarouselData[index].checked;
				CarouselData.map(v => {
					if (v.checked) {
						checkedNums++;
					}
				})
				// console.log('checkedNums2', checkedNums, index)
				CarouselData.map(v => {
					if (checkedNums > 1) {
						if (v.name == "全部" && v.checked) {
							v.checked = false;
						}
					}
				})
				index--;
				if (checkedNums == 0) {
					index = -1;
					CarouselData[0].checked = true;
				}
				// if (index != 0) {
				// 	if (checkedNums > 1) {
				// 		CarouselData[0].checked = false;
				// 		CarouselData[index].checked = !CarouselData[index].checked;
				// 	} else if (!CarouselData[0].checked) {
				// 		CarouselData[0].checked = true;
				// 		CarouselData[index].checked = !CarouselData[index].checked;

				// 	}
				// } else if (index == 0 && CarouselData[0].checked) {
				// 	return;
				// }
				this.CarouselData = CarouselData;

				this.active = index
				this.$emit('transfer', {
					item,
					index,
					CarouselData
				})
			}
		},
	};
</script>
<style lang="less" scoped>
	.active {
		border: 3px solid pink;
		background-color: rgb(64, 79, 168);
	}
</style>
<style lang="less">
     .header {
        height: 80px;
        background-color: rgba(0,0,0,0.4) ;
        font-size: 18px;
        color: #fff;
        position: absolute;
        top: 0;
        width: 100%;
        min-width: 1800px;
        z-index: 999;
        opacity: 0.9;
        &-center {
            width: 1400px;
            margin: 0 auto;
            height: 80px;
        }


        .login {
            display: flex;
            align-items: center;
            line-height: 80px;

            img {
                position: relative;
                top: 10px;
                margin-right: 10px;
            }

            a {
                display: inline-block;
                position: relative;
                cursor: pointer;
            //    width: 48px;
           //     color: #666;
                height: 30px;
                padding: 0 15px;
                line-height: 30px;
                background-color: #eee;
                border-radius: 15px;

            }
        }

        .nologin {
            line-height: 80px;

            a {
                font-size: 18px;
              //  font-weight: 600;
                margin-right: 10px;
                color: #fff;
            }
        }

        &-sub {
            position: absolute;
            display: none;
            background: rgba(0, 0, 0, 0.5);
            width: 100%;
            z-index: 100;

            >li {
                line-height: 40px;
                color: #fff;
                border-bottom: 1px solid #fff;
                font-size: 14px;

                &:hover {
                    background: rgba(0, 0, 0, 0.6);
                }
            }
        }
        .lj_image{
            height: 80px;
           // width: 400px;
            display: flex;
            flex-direction: row;
            align-items: center;
            margin-right: 32px;
            .right{
                padding-top: 10px;
                font-size: 14px;
                .up{
                    height: 40px;
                    display: flex;
                    align-items: center;

                }
                .down{
                    height: 40px;
                }
            }
            .ljhead{
                height: 40px;position: relative;top: -5px;margin-right: 35px
            }
        }

        &-root {
            >li {
                width: 95px;
                line-height: 80px;
            //    color: #333;
                text-align: center;
                cursor: pointer;
                position: relative;



                &:hover {
                    background-color: rgba(0,0,0,0.3);
                    color: rgba(255,255,255);
                    display: block;


                }


                &:hover .header-sub {
                    display: block;
                    >li{
                        background-color: rgba(0,0,0,0.3) !important;
                        border:none;
                    }
                }
                &:hover .header-sub {
                   border-top: 5px solid #ffd54f;
                }


                &.active {
                    background: url('../../assets/img/navbg.png') no-repeat;
                    background-size: 100% 100%;
                    color: #fff;
                }
            }
        }

    }
	.card-carousel-wrapper {
		display: flex;
		align-items: center;
		justify-content: center;
		margin-top: 25px;
	}

	.card-carousel {
		display: flex;
		justify-content: center;
		width:850px;
        margin-left: 50px;
	}

	.card-carousel--overflow-container {
		overflow: hidden;
	}

	.card-carousel--nav__left,
	.card-carousel--nav__right {
		display: inline-block;
		width: 15px;
		height: 15px;
		padding: 10px;
		box-sizing: border-box;
		border-top: 4px solid #fff;
		border-right: 4px solid #fff;
		cursor: pointer;
		margin: 0 10px;
		transition: transform 150ms linear;
	}
	.card-carousel--nav__left {
		transform: rotate(-135deg);
		margin-right: 50px;
	}

	.card-carousel--nav__left:active {
		transform: rotate(-135deg) scale(0.9);
	}

	.card-carousel--nav__right {
		transform: rotate(45deg);
		margin-left: 50px;
	}

	.card-carousel--nav__right:active {
		transform: rotate(45deg) scale(0.9);
	}

	.card-carousel-cards {
		display: flex;
		transition: transform 150ms ease-out;
		transform: translatex(0px);
	}

	.card-carousel-cards .card-carousel--card {
		margin: 0 25px;
		text-align: center;
		cursor: pointer;
		box-shadow: 0 4px 15px 0 rgba(40, 44, 53, 0.06),
			0 2px 2px 0 rgba(40, 44, 53, 0.08);

		border-radius: 4px;
		z-index: 3;
		margin-bottom: 2px;
	}

	.card-carousel-cards .card-carousel--card:first-child {
		margin-left: 0;
	}

	/* .card-carousel-cards .card-carousel--card:last-child {
  margin-right: 0;
} */
	.card-carousel-cards .card-carousel--card p {
		width: 96px;
		color: #fff;
		font-size: 16px;
		margin-top: 10px;
	}

	.card-carousel-cards .card-carousel--card img {
		vertical-align: bottom;
		border-top-left-radius: 4px;
		border-top-right-radius: 4px;
		transition: opacity 150ms linear;
		user-select: none;
	}

	.card-carousel-cards .card-carousel--card img:hover {
		opacity: 0.5;
	}

	.card-carousel-cards img {
		width: 55px;
		height: 55px;
	}

	.card-carousel-cards .card-carousel--card--footer p {
		padding: 3px 0;
		margin: 0;
		margin-bottom: 2px;
		font-size: 19px;
		font-weight: 500;
		color: #2c3e50;
		user-select: none;
	}

	.bottom-footer {
		width: 100%;
		// height: 300px;
		position: absolute;
		// bottom: 0px;
		z-index: -5;
	}
	.footdiv {
		background-size: 100% 100%;
		position: relative;
		display: flex;
		justify-content: center;
		align-items: center;
		height: 100%;
		// bottom: 0;
	}

	.icon {
		position: relative;
	}
</style>